import successIcon from '@/assets/icons/success.svg'
import errorIcon from '@/assets/icons/error.svg'
import readyIcon from '@/assets/icons/info.svg'
import { WorkflowRunStatusType } from '@/constants/workflowHistory/workflowHistory'
import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner'

export const WorkflowRunStatus = ({
  workflowRunStatus
}: {
  workflowRunStatus: WorkflowRunStatusType
}) => {

  const getStatusIcon = (status: string) => {
    switch (status) {
      case WorkflowRunStatusType.SUCCESS:
        return <img src={successIcon} className="mr-2" />
      case WorkflowRunStatusType.ERROR:
        return <img src={errorIcon} className="mr-2" />
      case WorkflowRunStatusType.READY:
        return <img src={readyIcon} className="mr-2" />
      case WorkflowRunStatusType.PROCESSING:
        return <LoadingSpinner className="h-5 w-5 mr-2" />
      default:
        return null
    }
  }

  return (
    <div className="flex items-center justify-start w-16">
      {getStatusIcon(workflowRunStatus)}
      <p className='capitalize'>{workflowRunStatus}</p>
    </div>
  )
}
